import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import VeeValidateRU from 'vee-validate/dist/locale/ru'
import lang from 'element-ui/lib/locale/lang/ru-RU'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import GetTextPlugin from 'vue-gettext'
import translations from './translations'
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
// import store from './store'
import vueShortkey from 'vue-shortkey'
import VueTheMask from 'vue-the-mask'


import axiosPlugin from "./axiosPlugin.js";


// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar';
import Vue2Filters from 'vue2-filters'

// router setup
import routes from './routes/routes'

let apiDriver = require("./components/Actid/apiDriver").default;

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'
import 'animate.css/animate.min.css'

import VEmojiPicker from 'v-emoji-picker';
Vue.component('VEmojiPicker', VEmojiPicker);

import VueAnime from "vue-animejs";
Vue.use(VueAnime);

import VueTagsInput from '@johmun/vue-tags-input';
Vue.use(VueTagsInput);

// import VueTableDynamic from 'vue-table-dynamic';
// Vue.use(VueTableDynamic);
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);

import VModal from 'vue-js-modal';
Vue.use(VModal);

import InputModule from './components/Actid/Components/InputModule.vue'
Vue.component('input-module', InputModule);

import { vfmPlugin } from 'vue-final-modal'
Vue.use(vfmPlugin);

import Verte from 'verte';
import 'verte/dist/verte.css';
Vue.component('verte', Verte);

import VueToast from 'vue-toast-notification';
Vue.use(VueToast, {
  position: 'top-right'
});

import QrcodeVue from 'qrcode.vue'
Vue.component('qrcode', QrcodeVue);

import VueBreadcrumbs from 'vue-2-breadcrumbs';
Vue.use(VueBreadcrumbs);

// import sidebarLinks from './sidebarLinks'
// plugin setup
Vue.use(VueTheMask)
Vue.use(VueRouter);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(VueNotify);
Vue.use(SideBar); // , { sidebarLinks: sidebarLinks }

// Подключение валидатора на русском языке
VeeValidate.Validator.localize('ru', VeeValidateRU);
Vue.use(VeeValidate, { locale: 'ru', fieldsBagName: 'vvFields' });
locale.use(lang);
Vue.use(GetTextPlugin, {
  defaultLanguage: 'ru',
  translations: translations,
  silent: process.env.NODE_ENV === 'production'
});

Vue.filter('translate', value => {
  return !value
    ? ''
    : Vue.prototype.$gettext(value.toString())
});

Vue.use(vueShortkey);

import TextareaAutosize from 'vue-textarea-autosize'
Vue.use(TextareaAutosize)



// Подключаем модуль горячих клавиш

// configure router
const router = new VueRouter({
  // mode: 'history',
  // routes, // short for routes: routes
  // linkActiveClass: 'active'
  mode: 'history',
  scrollBehavior: function (to, from, savePosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes,
  linkActiveClass: 'active',
});

initProgress(router);

router.beforeEach(async (to, from, next) => {
  let userData = store.state.userData
  if (!userData) {
    await store.dispatch('updateUserData');
    userData = store.state.userData;
  }
  if (to.matched.some(record => record.meta.user_type)) {
    if (!to.meta.user_type.includes(userData.user.type)) {
      return next({
        path: '/404'
      })
    } else {
      return next()
    }
  }
  if (to.matched.some(record => record.meta.only_for_users)) {
    if (!to.meta.only_for_users.includes(userData.user.id)) {
      return next({
        path: '/404'
      })
    } else {
      return next()
    }
  }
  if (to.matched.some(record => record.meta.service_id)) {
    if (userData.subscriptions) {
      if (!userData.subscriptions.find(x => x.service_id === to.meta.service_id)) {
        return next({
          path: '/404'
        })
      } else {
        return next()
      }
    } else {
      return next({ path: '/404' })
    }
  } else {
    return next() // make sure to always call next()!
  }
})

Vue.use(axiosPlugin);

Vue.router = router;

App.router = Vue.router;


import authPlugin from './authPlugin';
Vue.use(authPlugin);


import PrettyCheckbox from 'pretty-checkbox-vue';

Vue.use(PrettyCheckbox);

// Vue.use(require('vue-moment'));

import YmapPlugin from 'vue-yandex-maps'
const ym_settings = {
  apiKey: '694d52dc-b141-406e-9c72-2ce1a3cf1841',
  lang: 'ru_RU',
  coordorder: 'latlong',
  version: '2.1'
}
Vue.use(YmapPlugin, ym_settings)



import x5GMaps from 'x5-gmaps'
Vue.use(x5GMaps, 'AIzaSyArcC_ndDyDh8fRiFSIHJ7_co-JxWHG-Go')

import { gmapsMap, gmapsMarker, gmapsPopup } from 'x5-gmaps'
Vue.component('gmaps-map', gmapsMap);
Vue.component('gmaps-marker', gmapsMarker);
Vue.component('gmaps-popup', gmapsPopup);


const moment = require('moment');
require('moment/locale/ru');
Vue.use(require('vue-moment'), {
  moment
});

import 'prismjs'
import 'prismjs/themes/prism.css'


import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {});
import "vue-wysiwyg/dist/vueWysiwyg.css";


Vue.config.productionTip = false;


import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    userData: undefined
  },
  mutations: {
    updateUserData(state, data) {
      state.userData = data;
    }
  },
  actions: {
    async updateUserData(state) {
      let data = await apiDriver.account();
      if (!data) {
        if (document.location.href.includes("/login")) return;
        localStorage.token = "";
        document.location.href = "/login"
      }
      store.commit('updateUserData', data);
    }
  }
})

new Vue({
  el: '#app',
  render: h => h(App),
  store
});

Vue.use(Vue2Filters);